function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["geojson", "style"],
  _excluded2 = ["selfIntersection", "limits"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import olSourceVector from 'ol/source/Vector';
import olLayerVector from 'ol/layer/Vector';
import * as olExtent from 'ol/extent';
import olInteractionDraw, { createRegularPolygon, createBox } from 'ol/interaction/Draw';
import olInteractionModify from 'ol/interaction/Modify';
import * as olEventsCondition from 'ol/events/condition';
import olOverlay from 'ol/Overlay';
import olFeature from 'ol/Feature';
import * as olGeom from 'ol/geom';
import LinearRing from 'ol/geom/LinearRing';
import GeometryCollection from 'ol/geom/GeometryCollection';
import olFormatGeoJSON from 'ol/format/GeoJSON';
import jstsOL3Parser from 'jsts/org/locationtech/jts/io/OL3Parser';
import { BufferOp, BufferParameters } from 'jsts/org/locationtech/jts/operation/buffer';
import isValidOp from 'jsts/org/locationtech/jts/operation/valid/IsValidOp';
var olParser = new jstsOL3Parser();
var geoJsonFormatter = new olFormatGeoJSON();
olParser.inject(olGeom.Point, olGeom.LineString, LinearRing, olGeom.Polygon, olGeom.MultiPoint, olGeom.MultiLineString, olGeom.MultiPolygon, GeometryCollection);
var arrayValuesEqual = function arrayValuesEqual(array1, array2) {
  return array1.length === array2.length && array1.every(function (value, index) {
    return value === array2[index];
  });
};
var firstAndLastCoordinatesEqual = function firstAndLastCoordinatesEqual(coordinates) {
  return coordinates.length > 1 && arrayValuesEqual(coordinates[0], coordinates[coordinates.length - 1]);
};
var hasEnoughCoordinatesForIntersect = function hasEnoughCoordinatesForIntersect(coordinates) {
  return coordinates.length > 4;
};
var INVALID_REASONS = {
  INTERSECTION: 'intersectionNotAllowed',
  AREA_SIZE: 'invalidAreaSize',
  LINE_LENGTH: 'invalidLineLenght'
};
var OPTIONS = {
  drawControl: true,
  modifyControl: true,
  allowMultipleDrawing: true,
  showMeasureOnMap: false,
  buffer: 0,
  bufferAccuracy: 10,
  // is number of line segments used to represent a quadrant circle
  sidesForCircle: 50 // is number of sides/vertices used to represent circle as polygon
};
var isModifyLimited = function isModifyLimited(shape) {
  return ['Square', 'Circle', 'Box'].includes(shape);
};

/**
 * @class Oskari.mapping.drawtools.plugin.DrawPlugin
 * Map engine specific implementation for draw tools
 */
Oskari.clazz.define('Oskari.mapping.drawtools.plugin.DrawPlugin',
/**
 * @method create called automatically on construction
 * @static
 */
function () {
  this._clazz = 'Oskari.mapping.drawtools.plugin.DrawPlugin';
  this._name = 'GenericDrawPlugin';
  this._bufferLayer = null;
  this._drawLayer = null;
  this._styles = {};
  this._overlays = {};
  this._drawFeatureIdSequence = 0;
  this._draw = null;
  this._modify = null;
  this._interacting = false;
  this._options = {};
  this._defaultStyle = {
    fill: {
      color: 'rgba(255,0,255,0.2)'
    },
    stroke: {
      color: 'rgba(0,0,0,1)',
      width: 2
    },
    image: {
      radius: 4,
      fill: {
        color: 'rgba(0,0,0,1)'
      }
    },
    text: {
      scale: 1.3,
      fill: {
        color: 'rgba(0,0,0,1)'
      },
      stroke: {
        color: 'rgba(255,255,255,1)',
        width: 2
      }
    }
  };
  this.loc = Oskari.getMsg.bind(null, 'DrawTools');
}, {
  /**
   * @method setStyles
   * - set styles for draw, modify and invalid
   *
   * @param {Object} styles. If not given, will set default styles
   */
  setStyles: function setStyles() {
    var _this = this;
    var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var setStyle = function setStyle(type) {
      var defForType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // overriding default style configured style
      var styleDef = jQuery.extend({}, _this._defaultStyle, defForType);
      _this._styles[type] = _this.getMapModule().getStyle(styleDef);
    };
    // setting default style for draw, modify and invalid
    ['draw', 'modify'].forEach(function (type) {
      return setStyle(type, styles[type]);
    });
    // style def for invalid can be intersect or invalid in request
    var invalid = styles.invalid || styles.intersect;
    setStyle('invalid', invalid);
  },
  setDefaultStyle: function setDefaultStyle(style) {
    this._defaultStyle = style;
  },
  getStyleFunction: function getStyleFunction() {
    var _this2 = this;
    return function (feature) {
      var _feature$getPropertie = feature.getProperties(),
        valid = _feature$getPropertie.valid,
        isFinished = _feature$getPropertie.isFinished;
      if (valid === false) {
        return _this2._styles.invalid;
      }
      if (isFinished) {
        return _this2._styles.modify;
      }
      return _this2._styles.draw;
    };
  },
  // used for interactions' style. Render style only for pointer to render Polygon's invalid style.
  getPointerStyleFunction: function getPointerStyleFunction() {
    var _this3 = this;
    return function (feature) {
      var type = feature.getGeometry().getType();
      return type === 'Point' ? _this3._styles.draw : null;
    };
  },
  getTempModifyStyle: function getTempModifyStyle() {
    // style (not array)
    return this._styles.modify[0].clone();
  },
  /**
   * @method draw
   * - activates draw and modify controls
   *
   * @param {String} id, that identifies the request
   * @param {String} shape: drawing shape: Point/Circle/Polygon/Box/Square/LineString
   * @param {Object} options
   */
  draw: function draw(id, shape, options) {
    if (this._gfiTimeout) {
      clearTimeout(this._gfiTimeout);
    }
    // disable gfi
    this.getMapModule().setDrawingMode(true);

    // remove previous draw and modify controls
    this._cleanupInternalState(options.clear);

    // setup request
    this._id = id;
    this._shape = shape;
    var geojson = options.geojson,
      style = options.style,
      opts = _objectWithoutProperties(options, _excluded);
    this.setOptionsForRequest(opts);
    this.setStyles(style);
    this.setFeaturesFromGeoJson(geojson);

    // activate draw and modify controls
    var _this$getOpts = this.getOpts(),
      drawControl = _this$getOpts.drawControl,
      modifyControl = _this$getOpts.modifyControl;
    if (drawControl) {
      this.addDrawInteraction();
    }
    if (modifyControl) {
      this.addModifyInteraction();
    }
  },
  setOptionsForRequest: function setOptionsForRequest() {
    var reqOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    /* backwards compatibility:
    *  - self intersection is moved from options to limits
    *  - buffer was used as radius with Circle
    */
    if (this.getShape() === 'Circle' && reqOpts.buffer && !reqOpts.radius) {
      reqOpts.radius = reqOpts.buffer;
      delete reqOpts.buffer;
    }
    var _reqOpts$selfIntersec = reqOpts.selfIntersection,
      selfIntersection = _reqOpts$selfIntersec === void 0 ? true : _reqOpts$selfIntersec,
      _reqOpts$limits = reqOpts.limits,
      reqLimits = _reqOpts$limits === void 0 ? {} : _reqOpts$limits,
      rest = _objectWithoutProperties(reqOpts, _excluded2);
    var limits = _objectSpread({
      selfIntersection: selfIntersection
    }, reqLimits);
    var options = _objectSpread(_objectSpread(_objectSpread({}, OPTIONS), rest), {}, {
      limits: limits
    });

    // add localized warning tooltips and buffer params to options as these doesn't change during request
    var locPath = options.modifyControl ? 'modify' : 'new';
    if (limits.area) {
      var formatted = this.getMapModule().formatMeasurementResult(limits.area, 'area', 0);
      var warn = this.loc(INVALID_REASONS.AREA_SIZE, {
        size: formatted
      });
      var tip = this.loc("".concat(locPath, ".area"));
      options.limits.areaTooltip = "".concat(warn, " ").concat(tip);
    }
    if (limits.length) {
      var _formatted = this.getMapModule().formatMeasurementResult(limits.length, 'line', 0);
      var _warn = this.loc(INVALID_REASONS.LINE_LENGTH, {
        length: _formatted
      });
      var _tip = this.loc("".concat(locPath, ".line"));
      options.limits.lengthTooltip = "".concat(_warn, " ").concat(_tip);
    }
    if (limits.selfIntersection) {
      var _warn2 = this.loc(INVALID_REASONS.INTERSECTION);
      var _tip2 = this.loc("".concat(locPath, ".area"));
      options.limits.intersectionTooltip = "".concat(_warn2, " ").concat(_tip2);
    }
    if (options.buffer || options.radius) {
      options.bufferParams = new BufferParameters(options.bufferAccuracy);
    }
    this._options = options;
  },
  _cleanupInternalState: function _cleanupInternalState(clearDrawing) {
    var map = this.getMap();
    map.removeInteraction(this._draw);
    map.removeInteraction(this._modify);
    this._cleanSketch();
    this._draw = null;
    this._modify = null;
    if (clearDrawing) {
      this.clearDrawing();
    }
  },
  setFeaturesFromGeoJson: function setFeaturesFromGeoJson(geojson) {
    var _this4 = this;
    if (!geojson) {
      return;
    }
    var featuresFromJson = geoJsonFormatter.readFeatures(geojson);
    // parse multi geometries to single geometries
    if (this.getOpts('allowMultipleDrawing') === 'multiGeom') {
      featuresFromJson = this.parseMultiGeometries(featuresFromJson);
    }
    featuresFromJson.forEach(function (f) {
      _this4.onNewFeature(f);
      _this4.onFinishedFeature(f, true);
    });
    this.getDrawSource().addFeatures(featuresFromJson);
  },
  // used only for editing multigeometries (allowMultipleDrawing === 'multiGeom')
  parseMultiGeometries: function parseMultiGeometries(features) {
    var createFeatures = function createFeatures(geometries) {
      return geometries.map(function (geometry) {
        return new olFeature({
          geometry: geometry
        });
      });
    };
    return features.flatMap(function (feat) {
      var geom = feat.getGeometry();
      var type = geom.getType();
      if (type === 'MultiPoint') {
        return createFeatures(geom.getPoints());
      }
      if (type === 'MultiLineString') {
        return createFeatures(geom.getLineStrings());
      }
      if (type === 'MultiPolygon') {
        return createFeatures(geom.getPolygons());
      }
      return feat;
    });
  },
  // for wrapping features to one feature with multi geometry used with 'multiGeom'
  createMultiGeometry: function createMultiGeometry(features) {
    if (!features.length) {
      return features;
    }
    var first = features[0];
    var coords = features.map(function (f) {
      return f.getGeometry().getCoordinates();
    });
    var geometry;
    switch (first.getGeometry().getType()) {
      case 'Point':
        geometry = new olGeom.MultiPoint(coords);
        break;
      case 'LineString':
        geometry = new olGeom.MultiLineString(coords);
        break;
      case 'Polygon':
        geometry = new olGeom.MultiPolygon(coords);
        break;
      default:
        throw new Error('Unsupported geometry type!');
    }
    var feature = new olFeature({
      geometry: geometry
    });
    feature.setId(first.getId());

    // Gather properties for createGeoJsonFeature => feature.geProperties
    var props = {
      valid: features.every(function (f) {
        return f.get('valid');
      }),
      length: features.map(function (f) {
        return f.get('length') || 0;
      }).reduce(function (s, l) {
        return s + l;
      }, 0),
      area: features.map(function (f) {
        return f.get('area') || 0;
      }).reduce(function (s, a) {
        return s + a;
      }, 0),
      radius: first.get('radius') || 0,
      buffer: first.get('buffer') || 0,
      tooltip: features.filter(function (f) {
        return f.get('valid') === false;
      }).map(function (f) {
        return f.get('tooltip');
      })[0]
    };
    feature.setProperties(props, true);
    return [feature];
  },
  /**
   * This is the shape type that is currently being drawn
   * @return {String} 'Polygon' / 'LineString' etc
   */
  getShape: function getShape() {
    return this._shape;
  },
  /**
   * Returns a source for drawn features.
   */
  getDrawSource: function getDrawSource() {
    if (!this._drawLayer) {
      this._drawLayer = this.createVectorLayer('DrawPluginLayer');
    }
    return this._drawLayer.getSource();
  },
  /**
   * Returns a source for buffered features.
   */
  getBufferSource: function getBufferSource() {
    if (!this._bufferLayer) {
      this._bufferLayer = this.createVectorLayer('DrawPluginBufferLayer');
    }
    return this._bufferLayer.getSource();
  },
  /**
   * @method addVectorLayer
   * -  adds a new layer to the map
   */
  createVectorLayer: function createVectorLayer(id) {
    var layer = new olLayerVector({
      id: id,
      source: new olSourceVector(),
      title: id
    });
    this.getMapModule().addOverlayLayer(layer, 'draw');
    return layer;
  },
  /**
   * The id sent in startdrawing request like "measure" or "feedback"
   * @return {String|Number}
   */
  getRequestId: function getRequestId() {
    return this._id;
  },
  /**
   * Each new geometry gets a "unique id" with this sequence
   * @return {String} [description]
   */
  generateNewFeatureId: function generateNewFeatureId() {
    return 'drawFeature' + this._drawFeatureIdSequence++;
  },
  /**
   * Returns a value in the options.
   * @param  {String} key  key for the value inside options
   * @return {Any}
   */
  getOpts: function getOpts(key) {
    if (key) {
      return this._options[key];
    }
    return this._options;
  },
  /**
   * @method stopDrawing
   * - used for clear or end drawing
   * - if id isn't given clears all drawings and doesn't send event
   * @param {String} id
   */
  stopDrawing: function stopDrawing(id, clearCurrent, supressEvent) {
    var _this5 = this;
    if (!id || clearCurrent) {
      this.clearDrawing(id);
    } else {
      // try to finish unfinished (currently drawn) feature
      this.forceFinishDrawing();
    }
    // only clear state if the stopped id is the current id
    // otherwise sending startDraw with id 2 and stop with id 1 will
    // remove the draw control from the draw id 2 when the requested one was 1
    var clearingAllOrCurrentDrawing = typeof id === 'undefined' || id === this.getRequestId();
    if (clearingAllOrCurrentDrawing) {
      if (id && !supressEvent) {
        this.sendDrawingEvent(true);
      }
      // remove draw and modify controls
      this._cleanupInternalState();
      // enable gfi
      this._gfiTimeout = setTimeout(function () {
        return _this5.getMapModule().setDrawingMode(false);
      }, 500);
    } else {
      Oskari.log('DrawPlugin').info("Called stop with id '".concat(id, "' and draw is currently active with id '").concat(this.getRequestId(), "'."));
    }
  },
  /**
   * @method forceFinishDrawing
   * Try to finish drawing if _scetch contains the unfinished (currently drawn) feature
   * Updates measurement on map and cleans sketch
   */
  forceFinishDrawing: function forceFinishDrawing() {
    var feature = this._sketch;
    if (!feature) {
      return;
    }
    var geom = feature.getGeometry();
    var source = this.getDrawSource();
    if (geom.getType() === 'LineString') {
      var coords = geom.getCoordinates();
      if (coords.length > 2) {
        var parsedCoords = coords.slice(0, coords.length - 1); // remove last point
        geom.setCoordinates(parsedCoords);
        source.addFeature(feature);
        this.updateMeasurements(feature);
      } else {
        // cannot finish geometry, remove measurement result from map
        this._cleanSketch();
      }
    } else if (geom.getType() === 'Polygon') {
      // only for exterior linear ring, drawtools doesn't support linear rings (holes)
      var _coords = geom.getCoordinates()[0];
      if (_coords.length > 4) {
        var _parsedCoords = _coords.slice(0, _coords.length - 2); // remove second last point
        _parsedCoords.push(_coords[_coords.length - 1]); // add last point to close linear ring
        geom.setCoordinates([_parsedCoords]); // add parsed exterior linear ring
        source.addFeature(feature);
        this.updateMeasurements(feature);
      } else {
        // cannot finish geometry, remove measurement result from map
        this._cleanSketch();
      }
    }
    this._sketch = null; // clean sketch to not add to drawing event
  },
  _cleanSketch: function _cleanSketch() {
    // Remove measure result from map
    if (this._sketch) {
      this.removeDrawingTooltip(this._sketch.getId());
    }
    this._sketch = null;
  },
  /**
   * @method clearDrawing
   * -  remove features from the draw layers
   * @param {String} functionality id. If not given, will remove features from all drawLayers
   */
  clearDrawing: function clearDrawing(id) {
    var _this6 = this;
    var drawSource = this.getDrawSource();
    var bufferSource = this.getBufferSource();
    // Clear all (e.g. another bundle sends stopdrawing)
    if (!id) {
      drawSource.clear();
      bufferSource.clear();
      Object.keys(this._overlays).forEach(function (id) {
        return _this6.removeDrawingTooltip(id);
      });
      this._overlays = {};
      return;
    }
    var remove = function remove(source, feat) {
      if (feat.get('requestId') === id) {
        _this6.removeDrawingTooltip(feat.getId());
        source.removeFeature(feat);
      }
    };
    drawSource.getFeatures().forEach(function (feat) {
      return remove(drawSource, feat);
    });
    bufferSource.getFeatures().forEach(function (feat) {
      return remove(bufferSource, feat);
    });

    // Freehand drawing (shift) has to be drawn by dragging
    // If user shift + clicks, drawn (invalid) feature isn't added to source and sketch is cleared
    // However drawing is started and useless tooltip is added  to map (showMeasureOnMap)
    // Delete point/vertex (modify) uses also shift key condition, so user may use shift + click while drawing
    this.clearDetachedTooltips();
  },
  /**
   * @method sendDrawingEvent
   * -  sends DrawingEvent
   *
   * @param {Boolean} isFinished  true - if drawing is completed. Default is false.
   */
  sendDrawingEvent: function sendDrawingEvent() {
    var isFinished = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var shape = this.getShape();
    var _this$getOpts2 = this.getOpts(),
      showMeasureOnMap = _this$getOpts2.showMeasureOnMap,
      buffer = _this$getOpts2.buffer;
    var features = this.getDrawFeatures();
    var bufferFeatures = [];
    if (buffer > 0) {
      bufferFeatures = this.getBufferFeatures();
    }
    if (!features.length && !bufferFeatures.length) {
      Oskari.log('DrawPlugin').debug('No features, skip send drawing event.');
      return;
    }
    var geojson = this.getFeaturesAsGeoJSON(features);
    var bufferedGeoJson = this.getFeaturesAsGeoJSON(bufferFeatures);
    var data = {
      buffer: buffer,
      shape: shape,
      showMeasureOnMap: showMeasureOnMap,
      bufferedGeoJson: bufferedGeoJson
    };
    var sumArea = 0;
    var sumLength = 0;
    features.forEach(function (f) {
      var _f$getProperties = f.getProperties(),
        area = _f$getProperties.area,
        length = _f$getProperties.length;
      if (area) sumArea += area;
      if (length) sumLength += length;
    });
    if (sumArea) data.area = sumArea;
    if (sumLength) data.length = sumLength;
    var event = Oskari.eventBuilder('DrawingEvent')(this.getRequestId(), geojson, data, isFinished);
    this.getSandbox().notifyAll(event);
  },
  getDrawFeatures: function getDrawFeatures() {
    return this._getFeatures(this.getDrawSource());
  },
  getBufferFeatures: function getBufferFeatures() {
    // sketch is always drawn feature, don't add it for buffer
    return this._getFeatures(this.getBufferSource(), true);
  },
  /**
   * @method getFeatures
   * -  gets features from layer
   *
   * @return {Array} features
   */
  _getFeatures: function _getFeatures(source, skipSketch) {
    if (!source) {
      return [];
    }
    var addSketch = this._sketch && !skipSketch;
    var reqId = this.getRequestId();
    var reqShape = this.getShape();
    var sketchId = addSketch ? this._sketch.getId() : '';
    var filterFeature = function filterFeature(feat) {
      // when modifying drawn feature, don't add dublicate feature
      if (addSketch && sketchId === feat.getId()) return false;
      var _feat$getProperties = feat.getProperties(),
        requestId = _feat$getProperties.requestId,
        shape = _feat$getProperties.shape;
      return requestId === reqId && shape === reqShape;
    };
    var features = source.getFeatures().filter(filterFeature);
    if (addSketch) {
      // include the unfinished (currently drawn) feature
      features.push(this._sketch);
    }
    return features;
  },
  /**
   * @method getFeaturesAsGeoJSON
   * - converts features to GeoJson
   * - adds measurements (length/area) as properties
   * - adds buffer as property if buffer is defined
   *
   * @param {Array} features
   * @return {String} geojson
   */
  getFeaturesAsGeoJSON: function getFeaturesAsGeoJSON(features) {
    var _this7 = this;
    if (this.getOpts('allowMultipleDrawing') === 'multiGeom') {
      features = this.createMultiGeometry(features);
    }
    return {
      type: 'FeatureCollection',
      crs: this.getSandbox().getMap().getSrsName(),
      features: features.map(function (f) {
        return _this7.createGeoJsonFeature(f);
      })
    };
  },
  createGeoJsonFeature: function createGeoJsonFeature(feature) {
    var json = geoJsonFormatter.writeFeatureObject(feature);
    var _feature$getPropertie2 = feature.getProperties(),
      length = _feature$getPropertie2.length,
      area = _feature$getPropertie2.area,
      radius = _feature$getPropertie2.radius,
      buffer = _feature$getPropertie2.buffer,
      tooltip = _feature$getPropertie2.tooltip,
      valid = _feature$getPropertie2.valid;
    var properties = {
      valid: valid
    };
    if (length) {
      properties.length = valid ? length : tooltip;
    }
    if (area) {
      properties.area = valid ? area : tooltip;
    }
    if (radius) {
      properties.radius = radius;
    }
    if (buffer) {
      properties.buffer = buffer;
    }
    // override
    json.properties = properties;
    return json;
  },
  /**
   * @method addDrawInteraction
   * -  activates draw control
   * @param {String} layerId
   * @param {String} shape
   * @param {Object} options
   */
  addDrawInteraction: function addDrawInteraction() {
    var _this8 = this;
    var shape = this.getShape();
    var _this$getOpts3 = this.getOpts(),
      radius = _this$getOpts3.radius,
      allowMultipleDrawing = _this$getOpts3.allowMultipleDrawing;
    var geometryFunction;
    var maxPoints;
    var type = shape;
    if (shape === 'LineString') {
      geometryFunction = function geometryFunction(coordinates, geometry) {
        if (!geometry) {
          geometry = new olGeom.LineString(coordinates);
        } else {
          geometry.setCoordinates(coordinates);
        }
        return geometry;
      };
    } else if (shape === 'Box') {
      maxPoints = 2;
      type = 'LineString';
      geometryFunction = createBox();
    } else if (shape === 'Point') {
      geometryFunction = function geometryFunction(coordinates, geometry) {
        if (!geometry) {
          geometry = new olGeom.Point(coordinates);
        }
        return geometry;
      };
    } else if (shape === 'Square') {
      type = 'Circle';
      geometryFunction = createRegularPolygon(4);
    } else if (shape === 'Circle' && radius > 0) {
      type = 'Point';
      geometryFunction = function geometryFunction(coordinates, geometry) {
        if (!geometry) {
          var point = new olGeom.Point(coordinates);
          geometry = _this8.getBufferedGeometry(point, radius);
        }
        return geometry;
      };
    } else if (shape === 'Circle') {
      var _this$getOpts4 = this.getOpts(),
        sidesForCircle = _this$getOpts4.sidesForCircle;
      geometryFunction = createRegularPolygon(sidesForCircle);
    } else if (shape === 'Polygon') {
      geometryFunction = function geometryFunction(coordinates, geometry) {
        // make closed Polygon
        var coords = coordinates.map(function (ring) {
          ring = ring.slice();
          ring.push(ring[0].slice());
          return ring;
        });
        if (!geometry) {
          geometry = new olGeom.Polygon(coords);
        } else {
          geometry.setCoordinates(coords);
        }
        return geometry;
      };
    }
    var wrappedFunction = function wrappedFunction() {
      var geometry = geometryFunction.apply(void 0, arguments);
      _this8.onSketchChange();
      return geometry;
    };
    var drawOpts = {
      type: type,
      maxPoints: maxPoints,
      source: this.getDrawSource(),
      style: this.getPointerStyleFunction(),
      geometryFunction: wrappedFunction
    };
    if (!Oskari.util.isMobile(true)) {
      // use smaller snap tolerance on desktop
      drawOpts.snapTolerance = 3;
    }
    this._draw = new olInteractionDraw(drawOpts);
    this._draw.on('drawstart', function (_ref) {
      var feature = _ref.feature;
      _this8._sketch = feature;
      _this8.onNewFeature();
      if (allowMultipleDrawing === 'single') {
        _this8.clearDrawing(_this8.getRequestId());
      }
      // stop modify interaction while draw-mode is active
      _this8.toggleModify(false);
    });
    this._draw.on('drawend', function () {
      if (allowMultipleDrawing === false) {
        _this8.toggleDraw(false);
      }
      // activate modify interaction after new drawing is finished
      _this8.toggleModify(true);
      _this8.onFinishedFeature();
    });
    this.getMap().addInteraction(this._draw);
  },
  toggleDraw: function toggleDraw(enabled) {
    if (this._draw) {
      this._draw.setActive(enabled);
    }
  },
  toggleModify: function toggleModify(enabled) {
    if (this._modify) {
      this._modify.setActive(enabled);
    }
  },
  onDrawingChange: function onDrawingChange(feature) {
    if (!feature) {
      return;
    }
    // update measurement before validating
    this.updateMeasurements(feature);
    // validate geometry before updating tooltip
    this.validateGeometry(feature);
    this.updateTooltip(feature);
    this.drawBuffer(feature);
  },
  // called on click for Point or pointer move for others
  onSketchChange: function onSketchChange() {
    this._interacting = true;
    this.onDrawingChange(this._sketch);
    this.sendDrawingEvent();
  },
  onFinishedFeature: function onFinishedFeature() {
    var feature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._sketch;
    var suppressEvent = arguments.length > 1 ? arguments[1] : undefined;
    this._interacting = false;
    feature.setProperties({
      isFinished: true
    }, true);
    this.onDrawingChange(feature);
    if (!suppressEvent) {
      this.sendDrawingEvent(true);
    }
    this._sketch = null;
  },
  onNewFeature: function onNewFeature() {
    var feature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._sketch;
    if (!feature.getId()) {
      feature.setId(this.generateNewFeatureId());
    }
    feature.setStyle(this.getStyleFunction());
    var requestId = this.getRequestId();
    var shape = this.getShape();
    feature.setProperties({
      requestId: requestId,
      shape: shape
    }, true);
  },
  validateGeometry: function validateGeometry(feature) {
    var limits = this.getOpts('limits');
    var geometry = feature.getGeometry();
    var type = geometry.getType();
    var _feature$getPropertie3 = feature.getProperties(),
      area = _feature$getPropertie3.area,
      length = _feature$getPropertie3.length,
      tooltip = _feature$getPropertie3.tooltip;
    var invalidReason;
    if (type === 'Polygon') {
      if (this.checkIntersection(feature)) {
        invalidReason = INVALID_REASONS.INTERSECTION;
        tooltip = limits.intersectionTooltip;
      } else if (limits.area && area > limits.area) {
        invalidReason = INVALID_REASONS.AREA_SIZE;
        tooltip = limits.areaTooltip;
      }
    }
    if (limits.length && type === 'LineString' && length > limits.length) {
      invalidReason = INVALID_REASONS.LINE_LENGTH;
      tooltip = limits.lengthTooltip;
    }
    var valid = !invalidReason;
    feature.setProperties({
      invalidReason: invalidReason,
      tooltip: tooltip,
      valid: valid
    }, true);
  },
  /**
   * @method checkIntersection
   * -  checks if feature's geometry intersects itself
   * @param {ol/Feature} feature
   * @param {Object} options
   */
  checkIntersection: function checkIntersection(feature) {
    // user can draw or modify intersecting polygons only if shape is polygon (not for Circle, Box, Square)
    if (this.getShape() !== 'Polygon' || !this.getOpts('limits').selfIntersection) {
      return false;
    }
    var geometry = feature.getGeometry();
    var coordinates = geometry.getCoordinates()[0];
    // This function is called twice when modifying geometry from the point where the drawing initially began
    // That is because the first and the last point of the geometry are being modified at the same time
    // The points should have identical values but in the first call they don't
    // So the first call is ignored by the if statement below since it would otherwise throw an error from a 3rd party library
    if (hasEnoughCoordinatesForIntersect(coordinates) && firstAndLastCoordinatesEqual(coordinates)) {
      if (!isValidOp.isValid(olParser.read(geometry))) {
        // lines intersect -> problem!!
        return true;
      }
    }
    return false;
  },
  updateMeasurements: function updateMeasurements(feature) {
    var mapmodule = this.getMapModule();
    var geom = feature.getGeometry();
    var format = this.getOpts('showMeasureOnMap');
    if (geom instanceof olGeom.Polygon) {
      var area = mapmodule.getGeomArea(geom);
      var length = mapmodule.getGeomLength(geom);
      var tooltip = format ? mapmodule.formatMeasurementResult(area, 'area') : '';
      feature.setProperties({
        area: area,
        length: length,
        tooltip: tooltip
      }, true);
      return;
    }
    if (geom instanceof olGeom.LineString) {
      var _length = mapmodule.getGeomLength(geom);
      var _tooltip = format ? mapmodule.formatMeasurementResult(_length, 'line') : '';
      feature.setProperties({
        length: _length,
        tooltip: _tooltip
      }, true);
    }
  },
  updateTooltip: function updateTooltip(feature) {
    var overlay = this.getDrawingTooltip(feature.getId());
    var geom = feature.getGeometry();
    var tooltipCoord;
    var _feature$getPropertie4 = feature.getProperties(),
      _feature$getPropertie5 = _feature$getPropertie4.tooltip,
      tooltip = _feature$getPropertie5 === void 0 ? '' : _feature$getPropertie5,
      valid = _feature$getPropertie4.valid;
    // don't show warning tooltip while drawing
    if (!valid && this._interacting) {
      tooltip = '';
    }
    if (geom instanceof olGeom.Polygon) {
      tooltipCoord = geom.getInteriorPoint().getCoordinates();
    } else if (geom instanceof olGeom.LineString) {
      tooltipCoord = geom.getLastCoordinate();
    }
    if (tooltipCoord) {
      overlay.setPosition(tooltipCoord);
    }
    var elem = overlay.getElement();
    elem.innerHTML = tooltip;
    if (tooltip) {
      elem.classList.remove('withoutText');
    } else {
      elem.classList.add('withoutText');
    }
  },
  /**
   * @method addModifyInteraction
   * -  activates modify control
   * @param {String} layerId
   * @param {String} shape
   * @param {Object} options
   */
  addModifyInteraction: function addModifyInteraction() {
    var isLimited = isModifyLimited(this.getShape());
    this._modify = new olInteractionModify({
      source: this.getDrawSource(),
      style: this.getPointerStyleFunction(),
      insertVertexCondition: isLimited ? olEventsCondition.never : olEventsCondition.always,
      deleteCondition: isLimited ? olEventsCondition.never : function (event) {
        return olEventsCondition.shiftKeyOnly(event) && olEventsCondition.singleClick(event);
      }
    });
    this.bindModifyEvents();
    this.getMap().addInteraction(this._modify);
  },
  /**
   * @method drawBufferedGeometry
   * -  adds buffered feature to the map
   *
   * @param {Geometry} geometry
   */
  drawBuffer: function drawBuffer(feature) {
    var _this$getOpts5 = this.getOpts(),
      buffer = _this$getOpts5.buffer;
    if (!buffer) {
      return;
    }
    var featGeom = feature.getGeometry();
    if (this.getShape() === 'Polygon' && featGeom.getCoordinates()[0].length < 4) {
      return;
    }
    var source = this.getBufferSource();
    var id = feature.getId();
    var bufferFeature = source.getFeatureById(id);
    var geometry = this.getBufferedGeometry(featGeom, buffer);
    if (bufferFeature) {
      bufferFeature.setGeometry(geometry);
      this.updateMeasurements(bufferFeature);
      return;
    }
    bufferFeature = new olFeature({
      geometry: geometry
    });
    // copy id from actual feature
    bufferFeature.setId(id);
    bufferFeature.setProperties({
      buffer: buffer,
      valid: true
    }, true);
    this.onNewFeature(bufferFeature);
    source.addFeature(bufferFeature);
    this.updateMeasurements(bufferFeature);
  },
  /**
   * @method modifyStartEvent
   * -  triggered upon feature modification start
   * @param {String} shape
   * @param {Object} options
   */
  bindModifyEvents: function bindModifyEvents() {
    var me = this;
    var shape = this.getShape();
    // if modifyend didn't get called for some reason, nullify the old listeners to be on the safe side
    if (this.modifyFeatureChangeEventCallback) {
      this.toggleDrawLayerChangeFeatureEventHandler(false);
      this.modifyFeatureChangeEventCallback = null;
    }
    var dragCoord;
    var startCoord;
    var updateDragCoord = function updateDragCoord(evt) {
      return dragCoord = evt.coordinate;
    };
    var tempStyle = this.getTempModifyStyle();
    this._modify.on('modifystart', function (evt) {
      var feature = evt.features.item(0);
      if (isModifyLimited(shape)) {
        dragCoord = evt.mapBrowserEvent.coordinate;
        if (shape === 'Box') {
          var coords = feature.getGeometry().getCoordinates()[0].slice(0, 4);
          var mapmodule = me.getMapModule();
          var maxDistance = 0;
          coords.forEach(function (coord) {
            var dist = mapmodule.getGeomLength(new olGeom.LineString([coord, dragCoord]));
            if (dist > maxDistance) {
              maxDistance = dist;
              startCoord = coord;
            }
          });
        } else {
          startCoord = me._getFeatureCenter(feature);
        }
        var tempFeature = new olFeature();
        tempFeature.setId(feature.getId());
        // use temp feature as sketch to get correct measurements and geojson to unfinished event
        me._sketch = tempFeature;
        me.getMap().on('pointerdrag', updateDragCoord);
      } else {
        me._sketch = feature;
      }
      me.modifyFeatureChangeEventCallback = function (_ref2) {
        var feature = _ref2.feature;
        // turn off changehandler in case something we touch here triggers a change event -> avoid eternal loop
        me.toggleDrawLayerChangeFeatureEventHandler(false);
        if (isModifyLimited(shape)) {
          var geomToRender = me.getModifiedGeometry(startCoord, dragCoord);
          // set rendered geometry to sketch to get correct measurements and geojson to unfinished event
          me._sketch.setGeometry(geomToRender);
          // modify interaction updates feature geometry so we can't set new geometry to feature
          // use style to render new geometry instead of actual
          tempStyle.setGeometry(geomToRender);
          feature.setStyle(tempStyle);
        }
        me.onSketchChange();
        // probably safe to start listening again
        me.toggleDrawLayerChangeFeatureEventHandler(true);
      };
      me.toggleDrawLayerChangeFeatureEventHandler(true);
    });
    this._modify.on('modifyend', function (evt) {
      me.getMap().un('pointerdrag', updateDragCoord);
      me.toggleDrawLayerChangeFeatureEventHandler(false);
      me.modifyFeatureChangeEventCallback = null;
      me._sketch = evt.features.item(0);
      var newGeom = me.getModifiedGeometry(startCoord, evt.mapBrowserEvent.coordinate);
      if (newGeom) {
        me._sketch.setGeometry(newGeom);
      }
      me.onFinishedFeature();
    });
  },
  toggleDrawLayerChangeFeatureEventHandler: function toggleDrawLayerChangeFeatureEventHandler(enable) {
    if (enable) {
      this.getDrawSource().on('changefeature', this.modifyFeatureChangeEventCallback, this);
    } else {
      this.getDrawSource().un('changefeature', this.modifyFeatureChangeEventCallback, this);
    }
  },
  getModifiedGeometry: function getModifiedGeometry(start, end) {
    if (!start || !end) {
      return;
    }
    var coords = [start, end];
    var shape = this.getShape();
    if (shape === 'Circle') {
      return createRegularPolygon(50)(coords);
    }
    if (shape === 'Square') {
      return createRegularPolygon(4)(coords);
    }
    if (shape === 'Box') {
      return createBox()(coords);
    }
  },
  /**
   * @method getBufferedFeature
   * -  creates buffered feature using given geometry and buffer. If style is given, adds style to feature
   *
   * @param {Geometry} geometry
   * @param {Number} buffer
   * @param {ol/style/Style} style
   * @param {Number} side amount of polygon
   * @return {ol/Geometry} geometry
   */
  getBufferedGeometry: function getBufferedGeometry(geometry, buffer) {
    var input = olParser.read(geometry);
    var bufferGeometry = BufferOp.bufferOp(input, buffer, this.getOpts('bufferParams'));
    bufferGeometry.CLASS_NAME = 'jsts.geom.Polygon';
    return olParser.write(bufferGeometry);
  },
  /**
   * @method  @private _getFeatureCenter get feature center coordinates.
   * @param  {ol/feature} feature feature where need to get center point
   * @return {Array} coordinates array
   */
  _getFeatureCenter: function _getFeatureCenter(feature) {
    var geom = feature.getGeometry();
    // Circle has (multi)polygon or (multi)point ol type and it center need calculated different way
    if (geom.getType().indexOf('Polygon') > -1 || geom.getType().indexOf('Point') > -1) {
      return olExtent.getCenter(geom.getExtent());
    }
    return geom.getCenter();
  },
  /** @method getDrawingTooltip
  * - returns tooltip and creates a new tooltip if not exist
  */
  getDrawingTooltip: function getDrawingTooltip(id) {
    if (this._overlays[id]) {
      return this._overlays[id];
    }
    var shape = this.getShape();
    var tooltipElement = document.createElement('div');
    tooltipElement.className = "drawplugin-tooltip-measure ".concat(shape, " ").concat(id);
    var tooltip = new olOverlay({
      element: tooltipElement,
      stopEvent: false,
      offset: [0, -5],
      positioning: 'bottom-center',
      id: id
    });
    this.getMap().addOverlay(tooltip);
    this._overlays[id] = tooltip;
    return tooltip;
  },
  removeDrawingTooltip: function removeDrawingTooltip(id) {
    var overlay = this._overlays[id];
    if (!overlay) {
      return;
    }
    this.getMap().removeOverlay(overlay);
    delete this._overlays[id];
  },
  // removes tooltips which aren't attached to any feature in draw source
  clearDetachedTooltips: function clearDetachedTooltips() {
    var _this9 = this;
    var overlayIds = Object.keys(this._overlays);
    var fetureIds = this.getDrawSource().getFeatures().map(function (f) {
      return f.getId();
    });
    var detachedIds = overlayIds.filter(function (id) {
      return !fetureIds.includes(id);
    });
    detachedIds.forEach(function (id) {
      return _this9.removeDrawingTooltip(id);
    });
  }
}, {
  extend: ['Oskari.mapping.mapmodule.plugin.AbstractMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  protocol: ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});